import { NgModule } from '@angular/core';

import { TicketingReportPageComponent } from "./ticketing-report-page.component";
import { CommonModule, DatePipe } from "@angular/common";
import { TicketingReportPageRouting } from "./ticketing-report-page.routing";
import { BtnModule } from "libraries/ui_button/btn.module";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";
import { SashaBreadcrumbModule } from "app_sasha/shared/components/breadcrumb/sasha-breacrumb.module";
import { TitleServiceModule } from "app_sasha/shared/services/title/title-service.module";
import { TicketingReportDomainService } from "./ticketing-report-domain.service";
import { AirTicketResourceModule } from "libraries/service/resources/air-ticket-resource/air-ticket-resource.module";
import { TicketingSearchFormComponent } from "./components/ticketing-search-form/ticketing-search-form.component";
import { SearchFormHelperService } from "app_sasha/shared/services/search-form-helper/search-form-helper.service";
import {
    TicketSearchFormMapperService
} from "./components/ticketing-search-form/ticketing-search-form-mapper.service";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TextModule } from "libraries/module/formbuilder/fields/text/text.module";
import { TicketingActionFieldsetComponent } from "./components/ticketing-search-form/ticketing-action-fieldset/ticketing-action-fieldset.component";
import { CollapsibleModule } from "libraries/component/collapsible/collapsible.module";
import { ChipsModule } from "libraries/module/formbuilder/fields/chips/chips.module";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { ComboboxFieldModule } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.module";
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { CardModule } from "libraries/ui_card/card.module";
import { DateRangeModule } from "libraries/module/formbuilder/fields/date-range/date-range.module";
import { TicketingBookingFieldsetComponent } from './components/ticketing-search-form/ticketing-booking-fieldset/ticketing-booking-fieldset.component';
import { TicketingTicketFieldsetComponent } from './components/ticketing-search-form/ticketing-ticket-fieldset/ticketing-ticket-fieldset.component';
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { EnumsResourceModule } from "libraries/service/booking/enums/enums-resource.module";
import { FieldConfigGetterPipe } from "./components/ticketing-search-form/ticketing-booking-fieldset/field-config-getter.pipe";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TicketingTableComponent } from './components/ticketing-table/ticketing-table.component';
import { TicketingDetailComponent } from './components/ticketing-table/ticketing-detail.component';
import { MatTableModule } from "@angular/material/table";
import { ThTextModule } from "libraries/component/table/th-text/th-text.module";
import { TdTextModule } from "libraries/component/table/td-text/td-text.module";
import { DatePipeModule } from "libraries/date/date.module";
import { PriceModule } from "libraries/component/price/price.module";
import { ExtractPricePipe } from "libraries/pipes/configurable-table/extract-price.pipe";
import { TicketingTableHelperService } from "./components/ticketing-table/ticketing-table-helper.service";
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { TicketingTableDomainService } from "./components/ticketing-table/ticketing-table-domain.service";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { PaginationModule } from "libraries/component/pagination/pagination.module";
import { SorterModule } from "libraries/component/sorter/sorter.module";
import { CompleteLabelModule } from "libraries/pipes/complete-label/complete-label.module";
import { PipesModule } from "libraries/pipes/pipes.module";
import {
    TicketCritCountPipe,
    TicketCritCountStringPipe
} from "./components/ticketing-search-form/ticket-crit-count.pipe";
import { CardFormModule } from "libraries/module/formbuilder/forms/card-form/card-form.module";
import { CustomFieldsComponent } from "./components/ticketing-table/custom-fields.component";
import { FieldDescriptionModule } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.module";
import { ClickOutsideModule } from "libraries/ui_clickOutside/clickOutside.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { LabelModule } from "libraries/service/label/label.module";
import { SearchFormHelperModule } from "app_sasha/shared/services/search-form-helper/search-form-helper.module";
import { ConfigurableTablePipeModule } from "libraries/pipes/configurable-table/configurable-table-pipe.module";

@NgModule({
    imports: [
        AirTicketResourceModule,
        BtnModule,
        CardFormModule,
        CardModule,
        ChipsModule,
        ClickOutsideModule,
        CollapsibleModule,
        ComboboxFieldModule,
        CommonModule,
        CompleteLabelModule,
        ConfigurationResourceModule,
        DateModule,
        DatePipeModule,
        DateRangeModule,
        EnumsResourceModule,
        FieldDescriptionModule,
        FontAwesomeModule,
        FormsModule,
        HostAliasPipeModule,
        LabelModule,
        LoaderModule,
        LocalizedModule,
        MatTableModule,
        MultiselectModule,
        NotificationModule,
        NumberModule,
        PaginationModule,
        PermissionModule,
        PipesModule,
        PriceModule,
        ReactiveFormsModule,
        SashaBreadcrumbModule,
        SorterModule,
        TdTextModule,
        TextModule,
        ThTextModule,
        TicketingReportPageRouting,
        TitleServiceModule,
        SearchFormHelperModule,
        ConfigurableTablePipeModule
    ],
    exports: [TicketingReportPageComponent],
    declarations: [
        TicketCritCountPipe,
        FieldConfigGetterPipe,
        TicketingActionFieldsetComponent,
        TicketingBookingFieldsetComponent,
        TicketingDetailComponent,
        TicketingReportPageComponent,
        TicketingSearchFormComponent,
        TicketingTableComponent,
        TicketingTicketFieldsetComponent,
        TicketCritCountStringPipe,
        CustomFieldsComponent,
    ],
    providers: [
        TicketCritCountPipe,
        TicketingReportDomainService,
        SearchFormHelperService,
        TicketSearchFormMapperService,
        TicketingTableHelperService,
        TicketingTableDomainService,
        ExtractPricePipe,
        DatePipe,
    ],
})
export class TicketingReportPageModule {
}
